import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    netSuiteItems: null,
    lastState: null,
    lastScope: null
};

const netSuiteItemsReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.NETSUITEITEM_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.NETSUITEITEM_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.NETSUITEITEM_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.NETSUITEITEM_LISTRESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default netSuiteItemsReducer;
